import { List, Avatar } from "antd";
import { first } from "lodash";
import { ISSOUser } from "pages/Auth/services/typings";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "themes/styled";
import { extractJwtPayload } from "utils/auth";

interface Props {
  data: ISSOUser;
  onItemClick?: (item: ISSOUser, loggedOut?: boolean) => void;
}

const UserItem: React.FC<Props> = (props) => {
  const { data: user, onItemClick } = props;
  const { t } = useTranslation();
  const isLoggedOut = !extractJwtPayload(user?.accessToken);
  return (
    <StyledItem onClick={() => onItemClick && onItemClick(user, isLoggedOut)}>
      <List.Item.Meta
        avatar={
          <Avatar src={user?.userInfo?.avatar_url} alt={user?.userInfo?.name}>
            {first(user?.userInfo?.name)}
          </Avatar>
        }
        title={<b>{user?.userInfo?.name}</b>}
        description={user?.userInfo?.email || user?.userInfo?.raw_email}
      />
      {isLoggedOut && (
        <div>
          <i>{t("auth.login.logged_out")}</i>
        </div>
      )}
    </StyledItem>
  );
};

const StyledItem = styled(List.Item)`
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.hover_color};
  }
`;

export default React.memo(UserItem);
